import React from 'react';
import {
  Alert,
  Box,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

import TaskGridPanel from './TaskGridPanel';
import BudgetLineGridPanel from './BudgetLineGridPanel';

type Props = {
  taskRows: any[];
  budgetRows: any[];
  accounts?: any[];
  loading?: boolean;

  onTaskRowsChange: (rows: any[]) => void;
  onBudgetRowsChange: (rows: any[]) => void;

  onSaveTasks: (rows: any[]) => Promise<void>;
  onSaveBudgetLines: (rows: any[]) => Promise<void>;
};

type State = {
  selectedTask: any | null;
};

class ActivityTaskBudgetPanel extends React.Component<Props, State> {
  state: State = {
    selectedTask: null,
  };

  getTaskId = (row: any) => row?.taskid || row?.rid || row?.id;

  componentDidUpdate(prevProps: Props) {
    const { selectedTask } = this.state;

    if (!selectedTask) return;

    const stillExists = (this.props.taskRows || []).some(
      (r: any) => String(this.getTaskId(r)) === String(this.getTaskId(selectedTask))
    );

    if (!stillExists) {
      this.setState({ selectedTask: null });
    }
  }

  selectTask = (selectedTask: any | null) => {
    this.setState({ selectedTask });
  };

  visibleBudgetRows = () => {
    const { selectedTask } = this.state;
    const { budgetRows } = this.props;

    if (!selectedTask) return [];

    const tid = this.getTaskId(selectedTask);

    return (budgetRows || []).filter((r: any) => {
      const rowTaskId = r.taskid || r.parentid || r.pri;
      return String(rowTaskId) === String(tid);
    });
  };

  mergeBudgetRows = (changedRowsForTask: any[]) => {
    const { selectedTask } = this.state;
    const { budgetRows } = this.props;

    if (!selectedTask) return;

    const tid = this.getTaskId(selectedTask);
    const changedIds = new Set(
      (changedRowsForTask || []).map((r: any) => String(r.id || r.rid || r.budgetlineid))
    );

    const unchangedOtherRows = (budgetRows || []).filter((r: any) => {
      const rowTaskId = r.taskid || r.parentid || r.pri;
      if (String(rowTaskId) !== String(tid)) return true;

      const rowId = String(r.id || r.rid || r.budgetlineid);
      return !changedIds.has(rowId);
    });

    this.props.onBudgetRowsChange([...unchangedOtherRows, ...(changedRowsForTask || [])]);
  };

  saveVisibleBudgetRows = async (rowsForTask: any[]) => {
    await this.props.onSaveBudgetLines(rowsForTask);
  };

  renderBudgetDetail() {
    const { selectedTask } = this.state;

    if (!selectedTask) {
      return (
        <Paper elevation={1} sx={{ p: 2, height: '100%' }}>
          <Stack spacing={1}>
            <Typography variant="h6">Budget Lines</Typography>
            <Alert severity="info">
              Select a task from the Tasks grid to view or add budget lines.
            </Alert>
          </Stack>
        </Paper>
      );
    }

    return (
      <BudgetLineGridPanel
        rows={this.visibleBudgetRows()}
        accounts={this.props.accounts || []}
        selectedTask={selectedTask}
        loading={this.props.loading}
        onChange={this.mergeBudgetRows}
        onSubmit={this.saveVisibleBudgetRows}
      />
    );
  }

  render0() {
    const { taskRows, loading, onTaskRowsChange, onSaveTasks } = this.props;
    const { selectedTask } = this.state;

    return (
      <Box>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, lg: 6 }}>
            <TaskGridPanel
              rows={taskRows || []}
              loading={loading}
              selectedTaskId={selectedTask ? this.getTaskId(selectedTask) : null}
              onTaskSelect={this.selectTask}
              onChange={onTaskRowsChange}
              onSubmit={onSaveTasks}
            />
          </Grid>

          <Grid size={{ xs: 12, lg: 6 }}>
            {this.renderBudgetDetail()}
          </Grid>
        </Grid>
      </Box>
    );
  }



  render() {
    const { taskRows, loading, onTaskRowsChange, onSaveTasks } = this.props;
    const { selectedTask } = this.state;

    return (
      <Box>
        <Paper elevation={0} sx={{ p: 0 }}>
            <TaskGridPanel
              rows={taskRows || []}
              loading={loading}
              selectedTaskId={selectedTask ? this.getTaskId(selectedTask) : null}
              onTaskSelect={this.selectTask}
              onChange={onTaskRowsChange}
              onSubmit={onSaveTasks}
            />
            { (!selectedTask) &&
              (
                <Stack spacing={1}>
                  <Typography variant="h6">Budget Lines</Typography>
                  <Alert severity="info">
                    Select a task from the Tasks grid to view or add budget lines.
                  </Alert>
                </Stack>
              )
            }
            { (selectedTask) &&
              (
                <BudgetLineGridPanel
                  rows={this.visibleBudgetRows()}
                  accounts={this.props.accounts || []}
                  selectedTask={selectedTask}
                  loading={this.props.loading}
                  onChange={this.mergeBudgetRows}
                  onSubmit={this.saveVisibleBudgetRows}
                />
              )
            }
        </Paper>
      </Box>
    );
  }
}

export default ActivityTaskBudgetPanel;


